const Games = [
	{
		name: 'Spades',
		image: 'https://cardsjd.com/config/more-games-icons/spades.png',
		FBInstant: '1076879022772932',
		ios: 'itms-apps://itunes.apple.com/app/id6458878117',
		android: 'https://play.google.com/store/apps/details?id=com.jdsoftwarellc.spades',
		windowsStoreProtocoLink: 'ms-windows-store://pdp/?productid=9NN5MHQV0NFV',
		windows: 'https://www.microsoft.com/store/apps/9NN5MHQV0NFV',
		web: 'https://cardsjd.com/spades',
	}, {
		name: 'Hearts',
		image: 'https://cardsjd.com/config/more-games-icons/hearts.png',
		FBInstant: '1388261732063000',
		ios: 'itms-apps://itunes.apple.com/app/id6476223216',
		android: 'https://play.google.com/store/apps/details?id=com.jdsoftwarellc.hearts',
		windowsStoreProtocoLink: 'ms-windows-store://pdp/?productid=9NCRQB9643L7',
		windows: 'https://www.microsoft.com/store/apps/9NCRQB9643L7',
		web: 'https://cardsjd.com/hearts/',
	}, {
		name: 'GinRummy',
		image: 'https://cardsjd.com/config/more-games-icons/ginrummy.png',
		FBInstant: '1150157359290701',
		ios: 'itms-apps://itunes.apple.com/app/id6470861992',
		android: 'https://play.google.com/store/apps/details?id=com.jdsoftwarellc.ginrummy',
		windowsStoreProtocoLink: 'ms-windows-store://pdp/?productid=9P5NP9RMRQQ6',
		windows: 'https://www.microsoft.com/store/apps/9P5NP9RMRQQ6',
		web: 'https://cardsjd.com/ginrummy/',
	}, {
		name: 'Cribbage',
		image: 'https://cardsjd.com/config/more-games-icons/cribbage.png',
		FBInstant: '1264960130273679',
		ios: 'itms-apps://itunes.apple.com/app/id1362318446',
		android: 'https://play.google.com/store/apps/details?id=com.jdsoftwarellc.cribbage',
		windows: 'https://www.microsoft.com/store/apps/9NTJ99B0PBLJ',
		windowsStoreProtocoLink: 'https://www.microsoft.com/store/apps/9NTJ99B0PBLJ',
		web: 'https://cardsjd.com/cribbage/',
		amazon: 'amzn://apps/android?asin=B07BMRYW6D',
	}, {
		name: 'Speed',
		image: 'https://cardsjd.com/config/more-games-icons/speed.png',
		FBInstant: '401658098090396',
		ios: 'itms-apps://itunes.apple.com/app/id914247866',
		android: 'https://play.google.com/store/apps/details?id=com.jimmyinteractive.speed',
		windowsStoreProtocoLink: 'ms-windows-store://pdp/?productid=9WZDNCRFJ2SB',
		windows: 'https://www.microsoft.com/store/apps/9WZDNCRFJ2SB',
		web: 'https://cardsjd.com/speed/',
	}, {
		name: 'Nertz',
		image: 'https://cardsjd.com/config/more-games-icons/nertz.png',
		FBInstant: '',
		ios: 'itms-apps://itunes.apple.com/app/id1089058813',
		android: 'https://play.google.com/store/apps/details?id=com.jimmyinteractive.nertz',
		windowsStoreProtocoLink: 'ms-windows-store://pdp/?productid=9WZDNCRCWPPB',
		windows: 'https://www.microsoft.com/store/apps/9WZDNCRCWPPB',
		web: 'https://cardsjd.com/nertz/',
	}, {
		name: 'Solitaire',
		image: 'https://cardsjd.com/config/more-games-icons/solitaire.png',
		FBInstant: '',
		ios: 'itms-apps://itunes.apple.com/app/id1042411982',
		android: 'https://play.google.com/store/apps/details?id=com.jimmyinteractive.solitaire',
		windowsStoreProtocoLink: 'ms-windows-store://pdp/?productid=9WZDNCRDKJTJ',
		windows: 'https://www.microsoft.com/store/apps/9WZDNCRDKJTJ',
		web: 'https://cardsjd.com/solitaire/',
	}, {
		name: 'Minesweeper',
		image: 'https://cardsjd.com/config/more-games-icons/minesweeper.png',
		FBInstant: '',
		ios: 'https://itunes.apple.com/us/app/minesweeper-classic-mine-sweeper/id1163024893?mt=8',
		android: 'https://play.google.com/store/apps/details?id=com.jimmyinteractive.minesweeper',
		windowsStoreProtocoLink: '',
		windows: 'https://cardsjd.com/minesweeper/',
		web: 'https://cardsjd.com/minesweeper/',
	},
];

export default Games;
